import { createContext, useContext } from 'react'

import { useAuth } from '../../Shared/Contexts/AuthContext'

const TestsContext = createContext({})

export const useTests = () => {
  return useContext(TestsContext)
}

export const TestsProvider = ({ children }) => {
  const { useBaseAxiosPost, useBaseAxiosGet } = useAuth()

  const useFetchGateway = async (payload) => {
    return await useBaseAxiosPost({ url: '/gateways/search', payload })
  }

  const useFetchTrackers = async (technology) => {
    return await useBaseAxiosGet({ url: `/field-meters/${technology}` })
  }

  const usePollDevicesMeasures = async (from, deviceId) => {
    return await useBaseAxiosGet({ url: `/${deviceId}/measures`, params: { withStatistics: true, withLinkStatuses: true, from: from, to: new Date().toISOString() } })
  }

  const useStartTest = async (payload, deviceId) => {
    return await useBaseAxiosPost({ url: `/devices/tests/${deviceId}`, payload })
  }

  const useGetTestConfig = async () => {
    return await useBaseAxiosGet({ url: '/gateways/tests/config' })
  }

  const useSaveGatewayTest = async (payload, serial) => {
    return await useBaseAxiosPost({ url: `/gateways/tests/${serial}`, payload })
  }

  const useGetSiteInfo = async (deviceId, from) => {
    return await useBaseAxiosGet({ url: '/site-validation', params: { fieldMeterId: deviceId, from: from, to: new Date().toISOString() } })
  }

  const useSaveDeviceTest = async (payload, deviceId) => {
    return await useBaseAxiosPost({ url: `/devices/tests/${deviceId}`, payload })
  }

  const value = {
    useFetchGateway,
    useFetchTrackers,
    useStartTest,
    useSaveGatewayTest,
    usePollDevicesMeasures,
    useGetSiteInfo,
    useSaveDeviceTest,
    useGetTestConfig
  }

  return (
    <TestsContext.Provider value={value}>{children}</TestsContext.Provider>
  )
}
